// Module
var code = `<img
  src="{{attrImageSrc}}"
  alt="{{attrImageAlt}}"
  width="1000"
  height="760"
  class="hidden md:block"
/>
`;
// Exports
module.exports = code;